module.exports = __webpack_public_path__ + "img/Groupama_AVIC.03a2a5d5.jpg";